import { AvailableLanguages } from '../../types/i18n';

const formatShortLangPrefix = (langId: string): AvailableLanguages => {
  if (langId.toLowerCase() === 'pt-br' || langId.toLowerCase() === 'sv-se') {
    return langId.toLowerCase().slice(0, 2) as AvailableLanguages;
  }

  return langId as AvailableLanguages;
};

export default formatShortLangPrefix;
